export const SET_SEGMENT_SENDING_LOCATION_IDS = 'SET_SEGMENT_SENDING_LOCATION_IDS';
export const SET_SEGMENT_SENDING_SELECTED_FOLLOWER_IDS = 'SET_SEGMENT_SENDING_SELECTED_FOLLOWER_IDS';
export const SET_SEGMENT_SENDING_EXCLUDED_FOLLOWER_IDS = 'SET_SEGMENT_SENDING_EXCLUDED_FOLLOWER_IDS';
export const SET_SEGMENT_SENDING_ALL_SELECTED = 'SET_SEGMENT_SENDING_ALL_SELECTED';
export const SET_SEGMENT_SENDING_SEGMENT_ID = 'SET_SEGMENT_SENDING_SEGMENT_ID';
export const SET_SEGMENT_SENDING_SMS_ELIGIBLE = 'SET_SEGMENT_SENDING_SMS_ELIGIBLE';
export const SET_SEGMENT_SENDING_EMAIL_ELIGIBLE = 'SET_SEGMENT_SENDING_EMAIL_ELIGIBLE';
export const SET_SEGMENT_SENDING_SOURCES = 'SET_SEGMENT_SENDING_SOURCES';
export const SET_SEGMENT_SENDING_TAG_IDS = 'SET_SEGMENT_SENDING_TAG_IDS';

export interface SegmentSendingState {
  allSelected: boolean;
  emailEligible: boolean;
  excludedFollowerIds: number[];
  locationIds: number[];
  segmentId: number | null;
  selectedFollowerIds: number[];
  smsEligible: boolean;
  sources: string[];
  tagIds: number[];
}

export const initialState: SegmentSendingState = {
  allSelected: false,
  emailEligible: false,
  excludedFollowerIds: [],
  locationIds: [],
  segmentId: null,
  selectedFollowerIds: [],
  smsEligible: false,
  sources: [],
  tagIds: [],
};

export type SegmentSendingAction =
  | { type: typeof SET_SEGMENT_SENDING_LOCATION_IDS; payload: { locationIds: number[] } }
  | { type: typeof SET_SEGMENT_SENDING_SELECTED_FOLLOWER_IDS; payload: { selectedFollowerIds: number[] } }
  | { type: typeof SET_SEGMENT_SENDING_EXCLUDED_FOLLOWER_IDS; payload: { excludedFollowerIds: number[] } }
  | { type: typeof SET_SEGMENT_SENDING_ALL_SELECTED; payload: { allSelected: boolean } }
  | { type: typeof SET_SEGMENT_SENDING_SEGMENT_ID; payload: { segmentId: number | null } }
  | { type: typeof SET_SEGMENT_SENDING_SMS_ELIGIBLE; payload: { smsEligible: boolean } }
  | { type: typeof SET_SEGMENT_SENDING_EMAIL_ELIGIBLE; payload: { emailEligible: boolean } }
  | { type: typeof SET_SEGMENT_SENDING_SOURCES; payload: { sources: string[] } }
  | { type: typeof SET_SEGMENT_SENDING_TAG_IDS; payload: { tagIds: number[] } };

const segmentSendingReducer = (
  state: SegmentSendingState = initialState,
  action: SegmentSendingAction,
): SegmentSendingState => {
  switch (action.type) {
    case SET_SEGMENT_SENDING_LOCATION_IDS:
      return { ...state, locationIds: action.payload.locationIds };
    case SET_SEGMENT_SENDING_SELECTED_FOLLOWER_IDS:
      return { ...state, selectedFollowerIds: action.payload.selectedFollowerIds };
    case SET_SEGMENT_SENDING_EXCLUDED_FOLLOWER_IDS:
      return { ...state, excludedFollowerIds: action.payload.excludedFollowerIds };
    case SET_SEGMENT_SENDING_ALL_SELECTED:
      return { ...state, allSelected: action.payload.allSelected };
    case SET_SEGMENT_SENDING_SEGMENT_ID:
      return { ...state, segmentId: action.payload.segmentId };
    case SET_SEGMENT_SENDING_SMS_ELIGIBLE:
      return { ...state, smsEligible: action.payload.smsEligible };
    case SET_SEGMENT_SENDING_EMAIL_ELIGIBLE:
      return { ...state, emailEligible: action.payload.emailEligible };
    case SET_SEGMENT_SENDING_SOURCES:
      return { ...state, sources: action.payload.sources };
    case SET_SEGMENT_SENDING_TAG_IDS:
      return { ...state, tagIds: action.payload.tagIds };
    default:
      return state;
  }
};

export default segmentSendingReducer;
